import { timelineEvents } from '@/mocks/home';

export default function EventTimeline() {
  return (
    <section id="timeline" className="bg-background-50 py-10 md:py-16 border-b border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-12 gap-8 md:gap-10">
          <div className="lg:col-span-4">
            <span className="text-xs font-label tracking-[0.2em] text-primary-600 uppercase">Timeline</span>
            <h2 className="mt-1.5 font-heading text-2xl md:text-3xl font-bold text-foreground-950">事件脉络一览</h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              以「某短剧平台分账争议」为样本，把每一次发声按时间顺序排开，标出仍有出入的节点，避免只看到半截截图就下判断。
            </p>
            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-4">
              <div className="flex items-center gap-2 text-sm text-foreground-800">
                <i className="ri-information-line text-primary-600"></i>
                节点状态说明
              </div>
              <ul className="mt-3 space-y-2 text-xs text-foreground-600">
                <li className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                  待证实：材料尚未完整公开
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                  已核查：有第三方或平台记录佐证
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                  有出入：双方口径暂时对不上
                </li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative border-l border-background-300 ml-2 md:ml-3">
              {timelineEvents.map((event) => (
                <li key={event.date} className="relative pl-6 md:pl-8 pb-6 last:pb-0">
                  <span className="absolute -left-[7px] top-1.5 w-3.5 h-3.5 rounded-full bg-background-50 border-2 border-primary-500"></span>
                  <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-5">
                    <div className="md:w-20 shrink-0">
                      <span className="font-heading text-lg font-bold text-primary-600">{event.date}</span>
                    </div>
                    <div className="flex-1 rounded-lg border border-background-200 bg-background-50 p-4">
                      <div className="flex flex-wrap items-center justify-between gap-2">
                        <h3 className="font-medium text-foreground-950">{event.title}</h3>
                        <span className="shrink-0 px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 text-xs">
                          {event.status}
                        </span>
                      </div>
                      <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{event.desc}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}